<template>
  <ul class="list-categories">
    <li
      v-for="category in links"
      :key="category.name"
      class="list-item-category mb-2"
    >
      <span class="category-name d-sm-inline-block mb-1">
        {{ category.name }}
      </span>
      <ul class="list-links">
        <li
          v-for="link in category.links"
          :key="link.href || link.to || link.title"
          :class="{ 'list-item-link': link.to || link.href }"
        >
          <router-link
            v-if="link.to"
            :to="{
              name: link.to,
              query: link.query || {
                key: link.inviteKey ? link.inviteKey : undefined,
              },
            }"
            class="text-body-2"
            :class="{ 'is-current-project': link.isCurrentProject }"
            @click="trackNavigation(link.to)"
          >
            {{ link.title }}
          </router-link>
          <a
            v-if="link.href"
            class="text-body-2"
            :class="{ 'is-current-project': link.isCurrentProject }"
            :href="link.href"
            v-bind="link.attributes"
            @click="trackNavigation(link.title)"
          >
            <span>{{ link.title }}</span>
            <v-icon
              v-if="link.postIcon && (link.to || link.href)"
              :icon="link.postIcon"
              :size="14"
            />
          </a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script setup>
defineProps({
  links: {
    type: Array,
    default: () => ([]),
  },
});

const emit = defineEmits(['tracking-event']);

const trackNavigation = (routeName) => {
  emit('tracking-event', { action: 'navLinkClick', args: { label: routeName } });
};
</script>

<style lang="less" scoped>
li {
  list-style-type: none;
}

.list-categories {
  min-width: 220px;
  width: 100%;
}

.category-name {
  text-transform: uppercase;
  color: @text-light;
  font-size: 11px;
}

.list-item-link {
  margin-top: 4px;
  border-radius: 8px;
  display: flex;
  align-items: center;

  a {
    display: inline-flex;
    align-items: center;
    width: 100%;
    height: 100%;
    color: @text-darkest;
    padding: 6px 8px;

    &.is-current-project {
      color: @primary;
    }
  }

  .v-icon {
    margin-left: auto;
    margin-right: 8px;

    :deep(path) {
      fill: @icon-default;
    }
  }
  &:hover {
    background-color: @bg-dark;
  }

  &:has(.router-link-active) {
    background-color: @bg-dark;
    border: 1px solid @stroke-default;
  }
}
</style>
